import { useRouteError } from 'react-router-dom';

import { Button } from '@/components/ui/button';

export function RouteErrorBoundary(): React.JSX.Element {
  // Intentionally do not render the error object — message/stack frames can
  // carry PHI from a failed API response (see docs/web/conventions.md §0.3).
  // The console boundary at boot is the only place the raw error surfaces.
  const error = useRouteError();
  console.error('[ema-web] route error boundary caught', error);

  function reload(): void {
    window.location.reload();
  }

  return (
    <main role="alert" className="min-h-screen flex items-center justify-center p-6">
      <div className="max-w-md w-full space-y-6 text-center">
        <h1 className="text-2xl font-semibold tracking-tight">Something went wrong</h1>
        <p className="text-sm text-muted-foreground">
          The page failed to load. Try again, or refresh if the problem persists.
        </p>
        <div className="flex justify-center">
          <Button type="button" onClick={reload}>
            Reload
          </Button>
        </div>
      </div>
    </main>
  );
}

export default RouteErrorBoundary;
